import { useEffect, useState } from "react";
import whiteStraightArrow from "../../../assets/icons/whiteArrowDown.svg";

const ArrowJumpingInStraightLine = () => {
    const [y, setY] = useState(window.scrollY);
    const [isScrolledToTheBotom, setIsScrolledToTheBottom] = useState<boolean>(false);

    useEffect(() => {
    window.addEventListener("scroll", (e) => handleNavigation(e));

    return () => { // return a cleanup function to unregister our function since its gonna run multiple times
        window.removeEventListener("scroll", (e) => handleNavigation(e));
    };
    }, [y]);

    const handleNavigation = (e: any) => {
        const unscrolledAreaHeight : number = 1000;
        const statisticsContainerHeight : any = document.querySelector('.statistics') as HTMLDivElement;
        const  heightOfElement : any = statisticsContainerHeight ? statisticsContainerHeight.offsetHeight : 0;
        const currentScrollHeight : any = window.scrollY + unscrolledAreaHeight;

        if (heightOfElement < currentScrollHeight)
            setIsScrolledToTheBottom(true);

        if (heightOfElement > currentScrollHeight)
            setIsScrolledToTheBottom(false);
    }    

    if (isScrolledToTheBotom)
        return <div></div>;

    return (
        <div className="statistics_arrow_down">
            <img className="white_arrow_statistics" src={whiteStraightArrow} alt="white arrow" />
        </div>
    )
}

export default ArrowJumpingInStraightLine;